export default "__VITE_ASSET__0e2f0b5d__"